export default "__VITE_ASSET__Dx1ZCBec__"